import { makeStyles } from "@material-ui/core/styles";
import * as settings from "../shared/settingsConstants"

const drawerWidth = 240;

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  scrollToTop: {
    position: "fixed",
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  drawer: {
    [theme.breakpoints.up("sm")]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  appBar: {
    [theme.breakpoints.up("sm")]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },
  toolBar: {
    backgroundColor: theme.palette.custom ? theme.palette.custom.toolbarBackground : settings.portalSettings.toolbarBackground,
    borderBottom: `5px solid ${theme.palette.custom ? theme.palette.custom.toolbarBorder : settings.portalSettings.toolbarBorder}`,
  },
  menuButton: {
    color: theme.palette.primary.main,
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  toolbar: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
  },
  toolbarSpacer: {
    flex: 1,
  },
  userMenuIcon: {
    marginRight: 12,
  },
  outerContainer: {
    [theme.breakpoints.down("xs")]: {
      padding: 0,
    },
  },
  innerContainer: {
    padding: "40px 0",
    [theme.breakpoints.down("xs")]: {
      padding: 0,
    },
  },
  containerPaper: {
    minHeight: 600,
  },
  contentContainer: {
    paddingTop: 20,
    paddingBottom: 100,
  },
  logoBar: {
    textAlign: "center",
    backgroundColor: theme.palette.custom ? theme.palette.custom.logoBackgroundColour : settings.portalSettings.logoBackgroundColour,
    borderBottom: `5px solid ${theme.palette.custom ? theme.palette.custom.toolbarBorder : settings.portalSettings.toolbarBorder}`,
  },
  drawerPaper: {
    width: drawerWidth,
    backgroundColor: theme.palette.custom ? theme.palette.custom.drawerBackground : settings.portalSettings.drawerBackground,
  },
  entityMenuList: {
    paddingTop: 25,
  },
  entityMenuCard: {
    backgroundColor: theme.palette.custom ? theme.palette.custom.drawerBackground : settings.portalSettings.drawerBackground,
  },
  entityMenu: {
    color: theme.palette.custom ? theme.palette.custom.drawerForeground : settings.portalSettings.drawerForeground,
  },
  drawerIcon: {
    color: theme.palette.custom ? theme.palette.custom.drawerForeground : settings.portalSettings.drawerForeground,
    minWidth: 0,
    marginRight: 10,
  },
  drawerListHeader: {
    fontWeight: "bold",
    color: theme.palette.custom ? theme.palette.custom.drawerForeground : settings.portalSettings.drawerForeground,   
  },
  drawerStamp: {
    position: "absolute",
    bottom: 25,
    marginLeft: 15,
    color: theme.palette.custom ? theme.palette.custom.drawerForeground : settings.portalSettings.drawerForeground,
    fontSize: 12,
    },
  toolbarIcon: {
    color: theme.palette.custom ? theme.palette.custom.toolbarForeground : settings.portalSettings.toolbarForeground,
  },
  authName: {
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
    marginRight: 5,
    color: theme.palette.custom ? theme.palette.custom.toolbarForeground : settings.portalSettings.toolbarForeground
  },
  logoContainer: {
    height: "100%",
    width: "100%",
    display: "inline-block",
    verticalAlign: "middle",
  },
  appLogoContainer: {
    height: "100%",
    width: "100%",
    display: "inline-block",
    verticalAlign: "middle",
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  }, 
  logo: {
    maxHeight: 60,
    padding: 5,
    marginRight: "auto",
    marginLeft: "auto",
    display: "block",
  },  
}));
